import { getCalendarEventIcon } from './getCalendarEventIcon';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';

export function getCalendarEventIcons(
    hasAttachments: boolean,
    isRecurring: boolean,
    isPrivate: boolean,
    isException: boolean
): IIconProps[] {
    const icons = [];
    if (isRecurring) {
        icons.push(getCalendarEventIcon('Recurring'));
    }
    if (hasAttachments) {
        icons.push(getCalendarEventIcon('HasAttachments'));
    }
    if (isException) {
        icons.push(getCalendarEventIcon('RecurringException'));
    }
    if (isPrivate) {
        icons.push(getCalendarEventIcon('Private'));
    }
    return icons;
}
